<template>
  <div ref="root" class="single-result">
    <div class="header">
      <AssetCount :assetCount="assetCount" />
    </div>
    <div v-if="!lhSrc" ref="live2d" class="live2d"></div>
    <img v-if="lhSrc" class="lh" :src="lhSrc" alt="立绘" />
    <div class="reference-line" :style="{ top: `${referenceLineTop}px` }"></div>
    <div ref="content" class="content">
      <div class="tag">{{ result.name }}</div>
      <div class="star">
        <div ref="reference" class="reference"></div>
        <img
          v-for="index in parseInt(result.star)"
          :key="index"
          class="icon"
          src="@/assets/zs_imgs/ck-single-star.png"
          alt="星"
        />
      </div>
      <div class="name">{{ result.role_name }}</div>
      <div class="fz">服装</div>
    </div>
    <div class="rate-wrap">
      <RateCount :num="maxNum" />
    </div>
  </div>
</template>
<script>
import RateCount from "./RateCount.vue";
import AssetCount from "./AssetCount.vue";

export default {
  name: "SingleResult",
  components: { RateCount, AssetCount },
  props: {
    cardResult: { type: Array, required: true },
    maxNum: { type: Number, default: 0 },
    assetCount: { type: Number, default: 0 }
  },
  data() {
    return {
      result: {},
      lhSrc: "",
      referenceLineTop: 0
    };
  },
  watch: {
    cardResult: {
      immediate: true,
      handler(array) {
        if (array.length > 0) {
          const result = array[0];
          const { lh, source } = JSON.parse(result.live2d);
          this.lhSrc = "";
          // if (source.value.atlas) {
          //   this.initLive2d(source.value);
          // } else {
          //   this.lhSrc = lh.value;
          // }
          if (lh.value) {
            this.lhSrc = lh.value;
            // this.lhSrc = "https://cdnimg-v2.gamekee.com/wiki2.0/video/50118/418239/2025/2/14/889650.png";
          } else if (source.value.atlas) {
            this.initLive2d(source.value);
          }
          this.result = result;
        }
      }
    }
  },
  mounted() {
    this.computeReferenceLineTop();
  },
  methods: {
    initLive2d({ atlas, json }) {
      const el = this.$refs.live2d;
      if (!el) {
        setTimeout(this.initLive2d, 30, { atlas, json });
        return;
      }
      const foramtUrl = url => {
        if (url.startsWith("//")) {
          return `${location.protocol}${url}`;
        } else {
          return url;
        }
      };
      window
        .fetch(json)
        .then(response => response.json())
        .then(data => {
          const animations = Object.keys(data.animations);
          el.innerHTML = null;
          // eslint-disable-next-line
          new window.spine.SpinePlayer(el, {
            jsonUrl: foramtUrl(json),
            // jsonUrl: foramtUrl(
            //   "http://cdnimg-v2.gamekee.com/wiki2.0/live2d/50118/236746/2025/0/20/char000301.skel.json"
            // ),
            atlasUrl: foramtUrl(atlas),
            // atlasUrl: foramtUrl(
            //   "http://cdnimg-v2.gamekee.com/wiki2.0/live2d/50118/236746/2025/0/20/char000301.skel.atlas"
            // ),
            animations: animations,
            showLoading: false,
            showControls: false,
            alpha: true,
            backgroundColor: "#00000000",
            success: function(player) {
              // _this.loading = false;
              // _this.isEmpty = false;
            }
          });
        });
    },
    async computeReferenceLineTop() {
      await new Promise(resolve => setTimeout(resolve, 50));
      /** @type {HTMLDivElement} */
      const el = this.$refs.reference;
      const { top } = el.getBoundingClientRect();

      const { top: rootTop } = this.$refs.root.getBoundingClientRect();
      this.referenceLineTop = top - rootTop;
      // this.referenceLineTop = top;
    }
  }
};
</script>
<style lang="less" scoped>
.single-result {
  height: 100%;
  transform: translateZ(1px);
  position: relative;
  background: url("~@/assets/zs_imgs/ck-single-bg.png") center / cover no-repeat;
  .header {
    position: absolute;
    top: 22px;
    right: 43px;
    left: 126px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .live2d {
    height: 100%;
  }
  .lh {
    position: absolute;
    width: 60%;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);
    object-fit: cover;
    object-position: center top;
    z-index: 1;
  }
  .reference-line {
    position: absolute;
    width: 100%;
    height: 1px;
    left: 70px;
    background-color: #487c91;
  }
  .content {
    position: absolute;
    top: 146px;
    left: 70px;
    right: 0;
    color: #487c91;
    z-index: 2;
    .tag {
      font-size: 30px;
      font-weight: 500;
    }
    .star {
      position: relative;
      display: flex;
      align-items: center;
      margin-top: 6px;
      .reference {
        position: absolute;
        width: 1px;
        height: 1px;
        top: 50%;
        transform: translateY(-50%);
        background-color: #487c91;
      }
    }
    .name {
      margin-top: 26px;
      font-size: 22px;
      font-weight: 500;
      line-height: 40px;
    }
    .fz {
      font-size: 18px;
      font-weight: 400;
    }
  }
  .rate-wrap {
    position: absolute;
    left: 48px;
    bottom: 30px;
  }
}
</style>
